module.exports = __webpack_public_path__ + "static/media/gwzrjsrxdfps.841b5929.png";